/* eslint-disable no-empty */
/* eslint-disable no-console */
import LocationService from "../../../services/masters/LocationService";
import serviceCalendar from "../../../services/calendar/CalendarService";
import serviceUser from "../../../services/user/UserService";
import {
  mapState
} from "vuex";
// import dayjs from "dayjs";

export default {
  props: ["providerId"],
  data() {
    // const today = new Date();
    return {
      statesData: [],
      enable: true,
      hasErrorState: false,
      hasErrorCity: false,
      hasErrorSchedule: false,
      hasErrorPhone: false,
      hasErrorCellphone: false,
      hasErrorAddress: false,
      hasErrorNumber1: false,
      hasErrorNumber2: false,
      hasErrorNumber3: false,
      dateALert: new Date(),
      citiesData: [],
      scheduleRangeData: [],
      cityIsLoading: false,
      notAllowedDays: [0],
      monthNames: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      dayNames: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      holidays: [],
      dia: 0,
      mes: 0,
      year: 0,
      addressA: [{
        name: "Anillo",
        id: 1
      },
      {
        name: "Autopista",
        id: 2
      },
      {
        name: "Avenida",
        id: 3
      },
      {
        name: "Avenida Calle",
        id: 4
      },
      {
        name: "Avenida Carrera",
        id: 5
      },
      {
        name: "Calle",
        id: 6
      },
      {
        name: "Carrera",
        id: 7
      },
      {
        name: "Circular",
        id: 8
      },
      {
        name: "Diagonal",
        id: 9
      },
      {
        name: "Transversal",
        id: 10
      },
      {
        name: "Zona",
        id: 11
      }
      ],
      propertyTypes: [
        {
          name: "-Tipo de inmueble-",
          id: 1
        },
        {
          name: "Edificio",
          id: 2
        },
        {
          name: "Hotel",
          id: 3
        },
        {
          name: "Oficina",
          id: 4
        },
        {
          name: "Urbanización",
          id: 5
        },
        {
          name: "Casa",
          id: 6
        }],
      blockOrInsides: [
        {
          name: "-Bloque o interior-",
          id: 1
        },
        {
          name: "Zona",
          id: 2
        },
        {
          name: "Manzana",
          id: 3
        },
        {
          name: "Bloque",
          id: 4
        },
        {
          name: "Habitación",
          id: 5
        },
        {
          name: "Apartamento",
          id: 6
        },
        {
          name: "Piso",
          id: 7
        }],
      daysOfWeek: [],
      forceShippingFee: [],
      isMinDateLoaded: false
    };
  },

  mounted() {
    this.getStates();
    this.getCities()
    this.getBranches()
    this.phone = this.$store.state.delivery.patient.phone,
      this.getForceShippingFee();
  },

  computed: {
    ...mapState("auth", ["user", "identification", "identificationType"]),

    isNextButtonDisable() {
      return (
        this.shippingFee === null ||
        this.shippingFee === undefined ||
        !this.nameNomenclature ||
        !this.numberOne ||
        !this.numberTwo ||
        !this.numberThree ||
        !this.phone ||
        !this.cellPhone ||
        this.phone.length <= 6 ||
        this.cellPhone.length <= 9 ||
        this.cellphoneEnable == false ||
        this.phoneEnable == false ||
        this.shippingDate < this.minDate ||
        this.schedule === ''
      )
    },
    provider: {
      get: function () {
        return this.$store.state.delivery.provider
      }
    },
    shippingDate: {
      get: function () {
        return this.$store.state.delivery.shippingDate
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateShippingDate', newValue)
      }
    },
    state: {
      get: function () {
        return this.$store.state.delivery.state
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateState', newValue)
      }
    },
    city: {
      get: function () {
        return this.$store.state.delivery.city
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateCity', newValue)
      }
    },
    branch: {
      get: function () {
        return this.$store.state.delivery.branch
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateBranch', newValue)
      }
    },
    schedule: {
      get: function () {
        return this.$store.state.delivery.schedule
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateSchedule', newValue)
      }
    },
    scheduleName: {
      get: function () {
        return this.$store.state.delivery.scheduleName
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateScheduleName', newValue)
      }
    },
    shippingFee: {
      get: function () {
        return this.$store.state.delivery.shippingFee
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateShippingFee', newValue)
      }
    },
    address: {
      get: function () {
        return this.$store.state.delivery.address
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateAddress', newValue)
      }
    },
    observations: {
      get: function () {
        return this.$store.state.delivery.observations
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateObservations', newValue)
      }
    },
    phone: {
      get: function () {
        return this.$store.state.delivery.phone
      },
      set: function (newValue) {
        this.$store.commit('delivery/updatePhone', newValue)
      }
    },
    cellPhone: {
      get: function () {
        return this.$store.state.delivery.cellPhone
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateCellPhone', newValue)
      }
    },
    nameNomenclature: {
      get: function () {
        return this.$store.state.delivery.nameNomenclature
      },
      set: function (newValue) {
        this.$store.commit('delivery/updatenameNomenclature', newValue)
      }
    },
    numberOne: {
      get: function () {
        return this.$store.state.delivery.numberOne
      },
      set: function (newValue) {
        this.$store.commit('delivery/updatenumberOne', newValue)
      }
    },
    numberTwo: {
      get: function () {
        return this.$store.state.delivery.numberTwo
      },
      set: function (newValue) {
        this.$store.commit('delivery/updatenumberTwo', newValue)
      }
    },
    numberThree: {
      get: function () {
        return this.$store.state.delivery.numberThree
      },
      set: function (newValue) {
        this.$store.commit('delivery/updatenumberThree', newValue)
      }
    },
    minDate: {
      get: function () {
        return this.$store.state.delivery.minDate
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateMinDate', newValue)
      }
    },
    maxDate: {
      get: function () {
        return this.$store.state.delivery.maxDate
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateMaxDate', newValue)
      }
    },
    propertyType: {
      get: function () {
        return this.$store.state.delivery.propertyType
      },
      set: function (newValue) {
        this.$store.commit('delivery/updatepropertyType', newValue)
      }
    },
    complementOne: {
      get: function () {
        return this.$store.state.delivery.complementOne
      },
      set: function (newValue) {
        this.$store.commit('delivery/updatecomplementOne', newValue)
      }
    },
    blockOrInside: {
      get: function () {
        return this.$store.state.delivery.blockOrInside
      },
      set: function (newValue) {
        this.$store.commit('delivery/updateblockOrInside', newValue)
      }
    },
    complementTwo: {
      get: function () {
        return this.$store.state.delivery.complementTwo
      },
      set: function (newValue) {
        this.$store.commit('delivery/updatecomplementTwo', newValue)
      }
    },
  },

  watch: {
    state() {
      this.getCities();
      if (this.schedule === '') {
        this.validateSchedule()
      }
    },

    city() {
      this.getBranches();
    },

    schedule() {
      if (this.schedule !== '' && this.schedule !== null) {
        this.shippingFee = this.scheduleRangeData
          .filter(scheduleRange => scheduleRange.id == this.schedule)
          .map(scheduleRange => scheduleRange.shippingFee)[0];
        let auxScheduleName = this.scheduleRangeData.find(scheduleRange => scheduleRange.id == this.schedule).range
        this.$store.commit('delivery/updateScheduleName', auxScheduleName)
      }
    },
    cellPhone() {
      this.validateNumberCellphone()
    },
    phone() {
      this.validateNumberphone()
    },
  },

  methods: {

    async getForceShippingFee() {
      try {
        let response = await LocationService.forceShippingFeeAll();
        if (response.data.code === 'No data available') {
          this.forceShippingFee = []
        } else {
          this.forceShippingFee = response.data
        }
      } catch (error) {
        console.log(error)
      }
    },

    onlyNumberAndLetters(e) {
      if (e.key.match(/[a-z0-9ñçáéíóú\s]/i) === null) {
        e.preventDefault();

      }
    },
    async getDates(branch,city) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await serviceCalendar.getAllowedDates(branch,city)
          const Dates = result.data;
          if (Dates.length < 10) {
            for (let i = 0; i < Dates.length; i++) {
              const aux = Dates[i];
              const input = aux.split("-");
              let dateAux = new Date(input[0], input[1] - 1, input[2]);
              this.daysOfWeek.push(dateAux);
            }
          } else {
            for (let i = 0; i < 10; i++) {
              const aux = Dates[i];
              const input = aux.split("-");
              let dateAux = new Date(input[0], input[1] - 1, input[2]);
              this.daysOfWeek.push(dateAux);
            }
          }
          // this.daysOfWeek = result.data;
          // let min = new Date(Dates[0].replace("-", "/"));
          let splittedDate = Dates[0].split('-')
          this.minDate = new Date(
            parseInt(splittedDate[0]),
            parseInt(splittedDate[1]) - 1,
            parseInt(splittedDate[2])
          )
          // let max = new Date(Dates[7].replace("-", "/"));
          if (Dates.length < 10) {
            splittedDate = Dates[Dates.length - 1].split('-')
          } else {
            splittedDate = Dates[9].split('-')
          }
          this.maxDate = new Date(
            parseInt(splittedDate[0]),
            parseInt(splittedDate[1]) - 1,
            parseInt(splittedDate[2])
          );
          this.shippingDate = this.minDate;
          this.isMinDateLoaded = true
          resolve()
        } catch (error) {
          this.isMinDateLoaded = false
          reject()
        }
      })
    },
    //Minimo de digitos para los campos de telefono
    minNum(e) {
      const key = e.key;
      if (/^\d{7}$/.test(key)) { } else {
        console.log(e);
        return e.preventDefault();
      }
    },

    filterKeyCount(e) {
      const key = e.key;
      if (/[0-9]/.test(key)) { } else {
        return e.preventDefault();
      }
    },

    observationSanitizer(newVal) {
      let re = /[^A-Z0-9# -]/gi;
      this.$store.commit('delivery/updateObservations', newVal.replace(re, ""))
    },

    onlyNumberAndLettersSanitizer(newVal, variable) {
      let re = /[^\w\s]/g
      this.$store.commit(`delivery/update${variable}`, newVal.replace(re, "").replace(/\s+/g, ' '))
    },

    onlyNumberAndLettersSanitizer2(newVal, variable) {
      let re = /[^\w\s]/g
      this.$store.commit(`delivery/update${variable}`, newVal.replace(re, "").replace(/\s+/g, ' '))
    },

    onlyNumberAndLettersSanitizer3(newVal, variable) {
      let re = /[^\w\s]/g
      this.$store.commit(`delivery/update${variable}`, newVal.replace(re, "").replace(/\s+/g, ' '))
    },

    contains(arr, id) {
      return arr.some(e => e.id === id);
    },

    async getStates() {
      let type = "EXCLUSIVE";
      if (this.provider === 1) {
        type = "INTEGRATED";
      }

      const response = await LocationService.getStatesByCountry(1, type, this.provider)
      this.statesData = response.data;
      if (!this.contains(this.statesData, this.state)) this.state = "";
      if (this.statesData.length === 0) {
        const message = this.$t("app.components.delivery.no-coverage-area");
        this.$buefy.toast.open({
          message,
          type: "is-warning"
        });
      }
    },

    async getCities() {
      try {
        if (!this.state) return;
        this.cityIsLoading = true;
        let type = "EXCLUSIVE";
        if (this.provider === 1) {
          type = "INTEGRATED";
        }
        const result = await LocationService.getCitiesByState(this.state, type, this.provider);

        this.citiesData = result.data;
        this.citiesData = this.citiesData.map(c => c.idCity)
        if (!this.contains(this.citiesData, this.city)) {
          this.city = "";
        }
        if (!this.contains(this.branches, this.branch)) {
          this.branch = "";
        }
        if (
          !this.contains(this.scheduleRanges, this.schedule)
        ) {
          this.schedule = "";
        }
        if (this.citiesData.length === 0) {
          const message = this.$t("app.components.delivery.no-coverage-area");
          this.$buefy.toast.open({
            message,
            type: "is-warning"
          });
        }

        this.cityIsLoading = false;
      } catch (error) {
        this.cityIsLoading = false;
      }
    },

    async getBranches() {
      if (!this.city) return;

      if (this.city) {
        this.schedule = "";
        this.scheduleRangeData = [];
      }

      let type = "EXCLUSIVE";
      if (this.provider === 1) {
        type = "INTEGRATED";
      }

      const response = await LocationService.getBranchesByCityAndProvider(
        this.city,
        this.provider,
        type
      );

      this.branches = response.data;
console.log('this city',this.city)
      if (this.branches && this.branches.length > 0) {
        if (this.branches[0].idUnifiedPharmacy !== null) {
          const response3 = await LocationService.getBranchesForUnifiedPharmacy(this.city)
          await this.getDates(response3.data[1].id, this.city);
          this.branch = this.branches[0].id;
        } else {
          this.branch = this.branches[0].id;
          await this.getDates(this.branch, this.city);
        }
        this.schedule = "";
        this.getScheduleRanges();
        // this.getDates(this.branch);
      } else {
        const message = this.$t("app.components.delivery.no-coverage-area");
        this.$buefy.toast.open({
          message,
          type: "is-warning"
        });
      }
    },

    async getScheduleRanges() {
      if (!this.branch) return;
      const response = await LocationService.getScheduleRangesByBranch(
        this.branch
      );
      this.scheduleRangeData = response.data.filter(
        sr => sr.idBranchCity.idCity.id === this.city
      );
      this.scheduleRangeData.forEach(
        sr =>
          (sr.range = `${sr.idScheduleRange.start} - ${sr.idScheduleRange.end}`)
      );
      if (!this.contains(this.scheduleRangeData, this.schedule))
        this.schedule = "";
    },
    validateNumberCellphone() {
      if (this.cellPhone[0] == '' || this.cellPhone[0] == undefined) {
        this.cellphoneEnable = false;
        return
      }
      if (this.cellPhone[0] != '3') {
        this.cellphoneEnable = false;
        this.$buefy.toast.open({
          duration: 2000,
          message: `El número celular debe empezar con el número 3`,
          type: 'is-danger'
        })
        return
      }

      if (this.cellPhone.length == 10) {
        this.cellphoneEnable = true;
        let count = 0;
        for (let i = 0; i < this.cellPhone.length; i++) {
          let numberInitial = this.cellPhone[0]

          if (numberInitial == this.cellPhone[i]) {
            count += 1;
          }
        }
        if (count > 10) {
          this.cellphoneEnable = false;
          this.$buefy.toast.open({
            duration: 4000,
            message: `Número inválido`,
            type: 'is-danger'
          })
          return
        }
      }
    },

    validateSchedule() {
      if (this.schedule === '') {
        this.$buefy.toast.open({
          duration: 2000,
          message: `El campo horario es obligarorio`,
          type: 'is-danger'
        })
        return
      }
    },

    validateNumberphone() {
      if (this.phone[0] == '' || this.phone[0] == undefined) {
        this.phoneEnable = false;
        return
      }
      if (this.phone.length > 7) {
        this.phoneEnable = true;
        let count = 0;
        for (let i = 0; i < this.phone.length; i++) {
          let numberInitial = this.phone[0]

          if (numberInitial == this.phone[i]) {
            count += 1;
          }
        }
        if (count >= 7) {
          this.phoneEnable = false;
          this.$buefy.toast.open({
            duration: 4000,
            message: `Número inválido`,
            type: 'is-danger'
          })
          return
        }
      }
    },
    async nextPage() {
      try {
        if (!this.state){
          this.hasErrorState = true
        } else {
          this.hasErrorState = false
        }
        
        let reg = /[A-Za-z]/
        if (!this.city || !reg){
          this.hasErrorCity = true
        } else {
          this.hasErrorCity = false
        }

        if (!this.schedule){
          this.hasErrorSchedule = true
        } else {
          this.hasErrorSchedule = false
        }

        if (!this.schedule){
          this.hasErrorSchedule = true
        } else {
          this.hasErrorSchedule = false
        }

        if (this.phone.length >= 1 && this.phone.length < 7){
          this.hasErrorPhone = true
        } else {
          this.hasErrorPhone = false
        }

        if (!this.cellPhone || this.cellPhone.length < 10) {
          this.hasErrorCellphone = true
        } else {
          this.hasErrorCellphone = false
        }

        if (!this.nameNomenclature) {
          this.hasErrorAddress = true
        } else {
          this.hasErrorAddress = false
        }

        if (!this.numberOne || this.numberOne === ' ') {
          this.hasErrorNumber1 = true
        } else {
          this.hasErrorNumber1 = false
        }

        if (!this.numberTwo || this.numberTwo === ' ') {
          this.hasErrorNumber2 = true
        } else {
          this.hasErrorNumber2 = false
        }

        if (!this.numberThree || this.numberThree === ' ') {
          this.hasErrorNumber3 = true
        } else {
          this.hasErrorNumber3 = false
        }

        this.hasErrorCellphone = this.cellPhone[0] !== '3'

        if (this.hasErrorState || this.hasErrorCity || this.hasErrorSchedule || this.hasErrorPhone || this.hasErrorCellphone 
          || this.hasErrorAddress || this.hasErrorNumber1 || this.hasErrorNumber2 || this.hasErrorNumber3 
          || this.hasErrorCellphone === true) {
           this.$buefy.toast.open({
              duration: 10000,
              message: `Revise los campos requeridos.`,
              pauseOnHover: true,
              type: 'is-danger'
          })
        } else {
          let address = this.nameNomenclature + ' ' + this.numberOne + ' # ' + this.numberTwo + ' - ' + this.numberThree
          this.address = address

          if (this.propertyType == "-Tipo de inmueble-") {
            this.propertyType = '';
          }
          if (this.blockOrInside == "-Bloque o interior-") {
            this.blockOrInside = '';
          }

          let response = await serviceUser.prioritizedPatient(this.identification, this.identificationType)
          let patient = response.data
          let forceShippingFeeAux = false
          this.forceShippingFee.map(fsf => {
            if (fsf.idCity.id === this.city && fsf.idProvider.id === this.provider) {
              forceShippingFeeAux = true
            }
          })
          if (!patient.code && !forceShippingFeeAux) {
            this.shippingFee = 0
          }
          this.$emit('nextStep')
        }

        if(/^\s+$/.test(this.numberOne)){
          this.hasErrorNumber1 = true
        }

        if(/^\s+$/.test(this.numberTwo)){
          this.hasErrorNumber2 = true
        }

        if(/^\s+$/.test(this.numberThree)){
          this.hasErrorNumber3 = true
        }
      } catch (error) {
        console.log(error)
      }
    },

    handlePaste() {
      const cleanedText = this.phone.match(/\d/g, '');
      this.phone = cleanedText ? cleanedText.slice(0,7).join('') : ''
    },

    handlePasteCellPhone() {
      const cleanedText = this.cellPhone.match(/\d/g, '');
      this.cellPhone = cleanedText ? cleanedText.slice(0,10).join('') : ''
    },

    validateSpace1(event) {
      if (event.key === ' ' && (this.numberOne === ' ')) {
        event.preventDefault();
      }
    },

    validateSpace2(event) {
      if (event.key === ' ' && (this.numberTwo === ' ')) {
        event.preventDefault();
      }
    },

    validateSpace3(event) {
      if (event.key === ' ' && (this.numberThree === ' ')) {
        event.preventDefault();
      }
    }
  }
};